<template>
  <div class="home">
    <div class="head-title">发票管理</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <nav>
            <el-select
              style="width: 24.0rem; display: inline-flex; min-width: auto"
              clearable
              v-model="fapiaoliang"
              placeholder="请选择状态"
              @change="getApplyInvoice"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="待审核" :value="1"></el-option>
              <el-option label="已审核" :value="2"></el-option>
              <el-option label="拒绝" :value="3"></el-option>
            </el-select>
          </nav>
          <div>
            <el-table
              :data="tableData.data"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
              style="margin-top: 2.0rem"
            >
              <el-table-column
                prop="money"
                label="审核的金额"
              ></el-table-column>
              <el-table-column
                prop="content"
                label="消费说明"
                min-width="200"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="account"
                label="代理商名称"
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="代理商手机号"
              ></el-table-column>
              <el-table-column
                prop="province"
                width="120"
                label="代理商归属省份"
              ></el-table-column>
              <el-table-column
                prop="city"
                width="120"
                label="代理商归属市区"
              ></el-table-column>
              <el-table-column prop="enterprisePhoto" label="营业执照">
                <template slot-scope="scope">
                  <el-image
                    style="width: 7.0rem; height: 7.0rem"
                    :src="scope.row.enterprisePhoto"
                    :preview-src-list="[scope.row.enterprisePhoto]"
                    fit="scale-down"
                  ></el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="check_content"
                label="审核内容"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="user_username"
                label="审核人"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="status_name" label="状态" width="100">
                <template slot-scope="scope">
                  <!-- <div v-if="scope.row.status == 2" style="color: #34bb4d">
                    已完成
                  </div>
                  <div v-if="scope.row.status == 3" style="color: #d91a1a">
                    驳回
                  </div>
                  <div v-if="scope.row.status == 1" style="color: #46aaf6">
                    待审核
                  </div> -->
                  <el-tag type="success"  v-if="scope.row.status == 2" size="mini">已完成</el-tag>
                  <el-tag type="danger"  v-if="scope.row.status == 3" size="mini">驳回</el-tag>
                  <el-tag  v-if="scope.row.status == 1" size="mini">待审核</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="addtime"
                label="申请时间"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column fixed="right" width="170" label="操作">
                <template slot-scope="scope">
                  <div v-if="scope.row.status == 1">
                    <el-button
                      size="mini"
                      @click="bianjis(scope.row)"
                      type="text"
                      >详情</el-button
                    >
                  </div>
                  <div v-if="scope.row.status == 2 || scope.row.status == 3">
                    <el-button
                      size="mini"
                      @click="bianji(scope.row)"
                      type="text"
                      >详情</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="paging">
              <pagination
                :total="tableData.total"
                :page.sync="listQuery.page"
                :limit.sync="listQuery.limit"
                :page-sizes="[10,20,50,100]"
                @pagination="getApplyInvoice"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      tooken: {},
      fapiaoliang: 0,
      tableData: {
        data: [],
        total: 0,
      },
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
      var a = document.title;
      document.title = title[0].website + "-" + a;
    }
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.tooken = userinfo;
    }
    this.getApplyInvoice();
  },
  methods: {
    bianji(val) {
      this.$router.push({
        name: "invoiceListadd",
        query: {
          val,
        },
      });
    },
    bianjis(val) {
      this.$router.push({
        name: "invoiceListadds",
        query: {
          val,
        },
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getApplyInvoice();
    },
    getApplyInvoice() {
      this.axios
        .post(
          "/api/Agent/getApplyInvoice",
          qs.stringify({
            totaltoken: this.tooken.totaltoken,
            status: this.fapiaoliang,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    fapiao() {
      this.fapiaoliang = 0;
      this.getApplyInvoice();
    },
    guanlian() {
      this.fapiaoliang = 1;
      this.getApplyInvoice();
    },
    weishenhe() {
      this.fapiaoliang = 2;
      this.getApplyInvoice();
    },
    jujue() {
      this.fapiaoliang = 3;
      this.getApplyInvoice();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table thead {
  color: #ffffff;
}
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0,0,0,0.1);
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  margin-top: 2.0rem;
  width: 100%;
  height: 90%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
}
.tongg {
  color: green;
}
.dengdai {
  color: rgb(64, 158, 255);
}
.bohui {
  color: red;
}
.tianjia {
  width: 100%;
  height: 100%;
}
.tianjia > main {
  font-size: 26px;
  /* margin-bottom: 4.0rem; */
}
.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
nav {
  width: 100%;
  // background-color: red;
}
nav > span {
  padding: 2.0rem;
  line-height: 8.0rem;
  cursor: pointer;
}
.blue {
  color: #fff;
  background-color: #298edb;
}
.invoice {
  width: 100%;
  height: 100%;
}
.body_none {
  width: 100%;
  height: 55.0rem;
  margin: 0 auto;
  padding: 3.0rem;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}
.body_nones {
  width: 80%;
  height: 100%;
  margin: 0 auto;
  padding: 3.0rem;
}
</style>

